module.exports = __webpack_public_path__ + "img/01_shoreline_library.4c09fff8.jpg";